module.exports = __webpack_public_path__ + "img/pasos-de-uso-4.c0b5a5de.svg";